import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getObligationList,
	addNewObligation,
	updateObligation,
	deleteObligation,
	getObligation,
} from '../obligation/thunk';

export const initialState = {
	itemObligationList: [],
	itemObligationDetail: null,
	isObligationLoading: false,
	isObligationSuccess: false,

	obligationList: [],
	obligationListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ObligationSlice = createSlice({
	name: 'Obligations',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getObligation.fulfilled, (state, action) => {
			state.isObligationLoading = false;
			state.isObligationSuccess = true;
			state.itemObligationDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getObligation.pending, state => {
			state.isObligationLoading = true;
			state.isObligationSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getObligation.rejected, (state, action) => {
			state.isObligationLoading = false;
			state.isObligationSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getObligationList.pending, state => {
			state.isObligationSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getObligationList.fulfilled, (state, action) => {
			state.itemObligationList = action.payload;
			state.obligationList = action.payload;
			state.isLoadingList = false;
			state.isObligationSuccess = true;

			let obligationListSelect = [];
			action.payload.map(item =>
				obligationListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.obligationListSelect = obligationListSelect;
		});
		builder.addCase(getObligationList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isObligationSuccess = true;
		});
		builder.addCase(addNewObligation.fulfilled, (state, action) => {
			state.itemObligationList.push(action.payload);
			state.obligationList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewObligation.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewObligation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateObligation.fulfilled, (state, action) => {
			// state.itemObligationList = state.itemObligationList.map(obligation =>
			// 	obligation.obligationname === action.payload.old_obligation
			// 		? { ...obligation, ...action.payload.updated_obligation }
			// 		: obligation
			// );
			console.log('obligation update: ', action.payload._id)
			state.obligationList = state.obligationList.map(obligation =>
				obligation._id.toString() === action.payload._id.toString()
					? { ...obligation, ...action.payload }
					: obligation
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateObligation.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateObligation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteObligation.fulfilled, (state, action) => {
			state.itemObligationList = current(state.itemObligationList).filter(
				item => item._id !== action.payload._id
			);
			state.obligationList = current(state.obligationList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteObligation.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteObligation.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ObligationSlice.actions;

export default ObligationSlice.reducer;
